module.exports = "<div id=inbox> <title title=Drafts></title> <div v-if=$loadingAsyncData class=\"mdl-spinner mdl-js-spinner is-active\"></div> <list v-if=!$loadingAsyncData :mails=mails></list> </div>";


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./src/Drafts.vue
 ** module id = 26
 ** module chunks = 0
 **/